// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as Card from "../../resources/layout-and-structure/Card.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as React from "react";
import * as Future from "rescript-future/src/Future.res.js";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as Scalar from "../../core/Scalar.res.js";
import * as Request from "../../core/Request.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as Placeholder from "../../resources/layout-and-structure/Placeholder.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as FuturePromise from "rescript-future/src/FuturePromise.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Client from "@apollo/client";
import * as Primitive_object from "@rescript/runtime/lib/es6/Primitive_object.js";
import * as ReactUpdateEffect from "../../primitives/ReactUpdateEffect.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Primitive_exceptions from "@rescript/runtime/lib/es6/Primitive_exceptions.js";
import * as CatalogDuplicationForm from "./CatalogDuplicationForm.res.js";
import * as ReasonMLCommunity__ApolloClient from "rescript-apollo-client/src/ReasonMLCommunity__ApolloClient.res.js";
import * as CatalogDuplicationSelectionTable from "./CatalogDuplicationSelectionTable.res.js";
import * as ApolloClient__React_Hooks_UseQuery from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseQuery.res.js";

let CatalogDuplication_ProductIdNotFound = /* @__PURE__ */Primitive_exceptions.create("CatalogDuplicationFormSelectionTableCard.CatalogDuplication_ProductIdNotFound");

let Raw = {};

let query = Client.gql(["query products($filterBy: InputProductsQueryFilter)  {\nproducts(first: 50, filterBy: $filterBy)  {\n__typename  \nedges  {\n__typename  \nnode  {\n__typename  \nid  \nshop  {\n__typename  \nid  \nname  \n}\n\ncategory  {\n__typename  \nid  \nformattedName  \nname  \nparent  {\n__typename  \nname  \n}\n\n}\n\nvariants(filterBy: {archived: INCLUDED})  {\n__typename  \nedges  {\n__typename  \nnode  {\n__typename  \ncku  \n}\n\n}\n\n}\n\n}\n\n}\n\n}\n\n}\n"]);

function parse(value) {
  let value$1 = value.products;
  let value$2 = value$1.edges;
  return {
    products: {
      __typename: value$1.__typename,
      edges: value$2.map(value => {
        let value$1 = value.node;
        let value$2 = value$1.shop;
        let value$3 = value$1.category;
        let tmp;
        if (value$3 == null) {
          tmp = undefined;
        } else {
          let value$4 = value$3.parent;
          tmp = {
            __typename: value$3.__typename,
            id: value$3.id,
            formattedName: value$3.formattedName,
            name: value$3.name,
            parent: !(value$4 == null) ? ({
                __typename: value$4.__typename,
                name: value$4.name
              }) : undefined
          };
        }
        let value$5 = value$1.variants;
        let value$6 = value$5.edges;
        return {
          __typename: value.__typename,
          node: {
            __typename: value$1.__typename,
            id: value$1.id,
            shop: {
              __typename: value$2.__typename,
              id: value$2.id,
              name: value$2.name
            },
            category: tmp,
            variants: {
              __typename: value$5.__typename,
              edges: value$6.map(value => {
                let value$1 = value.node;
                return {
                  __typename: value.__typename,
                  node: {
                    __typename: value$1.__typename,
                    cku: Scalar.CKU.parse(value$1.cku)
                  }
                };
              })
            }
          }
        };
      })
    }
  };
}

function serialize(value) {
  let value$1 = value.products;
  let value$2 = value$1.edges;
  let edges = value$2.map(value => {
    let value$1 = value.node;
    let value$2 = value$1.variants;
    let value$3 = value$2.edges;
    let edges = value$3.map(value => {
      let value$1 = value.node;
      let value$2 = value$1.cku;
      let value$3 = Scalar.CKU.serialize(value$2);
      let value$4 = value$1.__typename;
      let node = {
        __typename: value$4,
        cku: value$3
      };
      let value$5 = value.__typename;
      return {
        __typename: value$5,
        node: node
      };
    });
    let value$4 = value$2.__typename;
    let variants = {
      __typename: value$4,
      edges: edges
    };
    let value$5 = value$1.category;
    let category;
    if (value$5 !== undefined) {
      let value$6 = value$5.parent;
      let parent;
      if (value$6 !== undefined) {
        let value$7 = value$6.name;
        let value$8 = value$6.__typename;
        parent = {
          __typename: value$8,
          name: value$7
        };
      } else {
        parent = null;
      }
      let value$9 = value$5.name;
      let value$10 = value$5.formattedName;
      let value$11 = value$5.id;
      let value$12 = value$5.__typename;
      category = {
        __typename: value$12,
        id: value$11,
        formattedName: value$10,
        name: value$9,
        parent: parent
      };
    } else {
      category = null;
    }
    let value$13 = value$1.shop;
    let value$14 = value$13.name;
    let value$15 = value$13.id;
    let value$16 = value$13.__typename;
    let shop = {
      __typename: value$16,
      id: value$15,
      name: value$14
    };
    let value$17 = value$1.id;
    let value$18 = value$1.__typename;
    let node = {
      __typename: value$18,
      id: value$17,
      shop: shop,
      category: category,
      variants: variants
    };
    let value$19 = value.__typename;
    return {
      __typename: value$19,
      node: node
    };
  });
  let value$3 = value$1.__typename;
  let products = {
    __typename: value$3,
    edges: edges
  };
  return {
    products: products
  };
}

function serializeInputObjectProductKindEqualsFilter(inp) {
  let a = inp._equals;
  return {
    _equals: a === "SPIRITUOUS" ? "SPIRITUOUS" : (
        a === "BEER" ? "BEER" : (
            a === "WINE" ? "WINE" : "SIMPLE"
          )
      )
  };
}

function serializeInputObjectProductColorEqualsFilter(inp) {
  let a = inp._equals;
  return {
    _equals: a === "ORANGE" ? "ORANGE" : (
        a === "RED" ? "RED" : (
            a === "AMBER" ? "AMBER" : (
                a === "DARK" ? "DARK" : (
                    a === "BLACK" ? "BLACK" : (
                        a === "BLOND" ? "BLOND" : (
                            a === "ROSE" ? "ROSE" : "WHITE"
                          )
                      )
                  )
              )
          )
      )
  };
}

function serializeInputObjectInFilter(inp) {
  let a = inp._in;
  return {
    _in: a.map(b => b)
  };
}

function serializeInputObjectInputProductsQueryFilter(inp) {
  let a = inp.name;
  let a$1 = inp.kind;
  let a$2 = inp.producer;
  let a$3 = inp.color;
  let a$4 = inp.variantCkus;
  let a$5 = inp.shopIds;
  let a$6 = inp.archived;
  return {
    name: a !== undefined ? ({
        _equals: a._equals
      }) : undefined,
    kind: a$1 !== undefined ? serializeInputObjectProductKindEqualsFilter(a$1) : undefined,
    producer: a$2 !== undefined ? ({
        _equals: a$2._equals
      }) : undefined,
    color: a$3 !== undefined ? serializeInputObjectProductColorEqualsFilter(a$3) : undefined,
    variantCkus: a$4 !== undefined ? serializeInputObjectInFilter(a$4) : undefined,
    shopIds: a$5 !== undefined ? serializeInputObjectInFilter(a$5) : undefined,
    archived: a$6 !== undefined ? (
        a$6 === "ONLY" ? "ONLY" : (
            a$6 === "INCLUDED" ? "INCLUDED" : "EXCLUDED"
          )
      ) : undefined
  };
}

function serializeInputObjectStringEqualsFilter(inp) {
  return {
    _equals: inp._equals
  };
}

function serializeVariables(inp) {
  let a = inp.filterBy;
  return {
    filterBy: a !== undefined ? serializeInputObjectInputProductsQueryFilter(a) : undefined
  };
}

function makeVariables(filterBy) {
  return {
    filterBy: filterBy
  };
}

function makeInputObjectInputProductsQueryFilter(name, kind, producer, color, variantCkus, shopIds, archived, param) {
  return {
    name: name,
    kind: kind,
    producer: producer,
    color: color,
    variantCkus: variantCkus,
    shopIds: shopIds,
    archived: archived
  };
}

function makeInputObjectStringEqualsFilter(_equals, param) {
  return {
    _equals: _equals
  };
}

function makeInputObjectProductKindEqualsFilter(_equals, param) {
  return {
    _equals: _equals
  };
}

function makeInputObjectProductColorEqualsFilter(_equals, param) {
  return {
    _equals: _equals
  };
}

function makeInputObjectInFilter(_in, param) {
  return {
    _in: _in
  };
}

function makeDefaultVariables() {
  return {
    filterBy: undefined
  };
}

let ProductsQuery_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputProductsQueryFilter: serializeInputObjectInputProductsQueryFilter,
  serializeInputObjectStringEqualsFilter: serializeInputObjectStringEqualsFilter,
  serializeInputObjectProductKindEqualsFilter: serializeInputObjectProductKindEqualsFilter,
  serializeInputObjectProductColorEqualsFilter: serializeInputObjectProductColorEqualsFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter,
  makeVariables: makeVariables,
  makeInputObjectInputProductsQueryFilter: makeInputObjectInputProductsQueryFilter,
  makeInputObjectStringEqualsFilter: makeInputObjectStringEqualsFilter,
  makeInputObjectProductKindEqualsFilter: makeInputObjectProductKindEqualsFilter,
  makeInputObjectProductColorEqualsFilter: makeInputObjectProductColorEqualsFilter,
  makeInputObjectInFilter: makeInputObjectInFilter,
  makeDefaultVariables: makeDefaultVariables
};

let include = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query,
  Raw: Raw,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables
});

let useLazy = include.useLazy;

let ProductsQuery_refetchQueryDescription = include.refetchQueryDescription;

let ProductsQuery_use = include.use;

let ProductsQuery_useLazyWithVariables = include.useLazyWithVariables;

let ProductsQuery = {
  ProductsQuery_inner: ProductsQuery_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputProductsQueryFilter: serializeInputObjectInputProductsQueryFilter,
  serializeInputObjectStringEqualsFilter: serializeInputObjectStringEqualsFilter,
  serializeInputObjectProductKindEqualsFilter: serializeInputObjectProductKindEqualsFilter,
  serializeInputObjectProductColorEqualsFilter: serializeInputObjectProductColorEqualsFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter,
  makeVariables: makeVariables,
  makeInputObjectInputProductsQueryFilter: makeInputObjectInputProductsQueryFilter,
  makeInputObjectStringEqualsFilter: makeInputObjectStringEqualsFilter,
  makeInputObjectProductKindEqualsFilter: makeInputObjectProductKindEqualsFilter,
  makeInputObjectProductColorEqualsFilter: makeInputObjectProductColorEqualsFilter,
  makeInputObjectInFilter: makeInputObjectInFilter,
  makeDefaultVariables: makeDefaultVariables,
  refetchQueryDescription: ProductsQuery_refetchQueryDescription,
  use: ProductsQuery_use,
  useLazy: useLazy,
  useLazyWithVariables: ProductsQuery_useLazyWithVariables
};

let Raw$1 = {};

let query$1 = Client.gql(["query CategoriesQuery($filterByShopIds: InFilter, $filterByName: StringEqualsFilter, $filterByParentName: StringEqualsFilter)  {\ncategories(first: 1, filterBy: {archived: EXCLUDED, hasChildren: false, shopIds: $filterByShopIds, name: $filterByName, parentName: $filterByParentName})  {\n__typename  \nedges  {\n__typename  \nnode  {\n__typename  \nid  \nformattedName  \nshop  {\n__typename  \nid  \n}\n\n}\n\n}\n\n}\n\n}\n"]);

function parse$1(value) {
  let value$1 = value.categories;
  let value$2 = value$1.edges;
  return {
    categories: {
      __typename: value$1.__typename,
      edges: value$2.map(value => {
        let value$1 = value.node;
        let value$2 = value$1.shop;
        return {
          __typename: value.__typename,
          node: {
            __typename: value$1.__typename,
            id: value$1.id,
            formattedName: value$1.formattedName,
            shop: {
              __typename: value$2.__typename,
              id: value$2.id
            }
          }
        };
      })
    }
  };
}

function serialize$1(value) {
  let value$1 = value.categories;
  let value$2 = value$1.edges;
  let edges = value$2.map(value => {
    let value$1 = value.node;
    let value$2 = value$1.shop;
    let value$3 = value$2.id;
    let value$4 = value$2.__typename;
    let shop = {
      __typename: value$4,
      id: value$3
    };
    let value$5 = value$1.formattedName;
    let value$6 = value$1.id;
    let value$7 = value$1.__typename;
    let node = {
      __typename: value$7,
      id: value$6,
      formattedName: value$5,
      shop: shop
    };
    let value$8 = value.__typename;
    return {
      __typename: value$8,
      node: node
    };
  });
  let value$3 = value$1.__typename;
  let categories = {
    __typename: value$3,
    edges: edges
  };
  return {
    categories: categories
  };
}

function serializeInputObjectInFilter$1(inp) {
  let a = inp._in;
  return {
    _in: a.map(b => b)
  };
}

function serializeInputObjectStringEqualsFilter$1(inp) {
  return {
    _equals: inp._equals
  };
}

function serializeVariables$1(inp) {
  let a = inp.filterByShopIds;
  let a$1 = inp.filterByName;
  let a$2 = inp.filterByParentName;
  return {
    filterByShopIds: a !== undefined ? serializeInputObjectInFilter$1(a) : undefined,
    filterByName: a$1 !== undefined ? ({
        _equals: a$1._equals
      }) : undefined,
    filterByParentName: a$2 !== undefined ? ({
        _equals: a$2._equals
      }) : undefined
  };
}

function makeVariables$1(filterByShopIds, filterByName, filterByParentName) {
  return {
    filterByShopIds: filterByShopIds,
    filterByName: filterByName,
    filterByParentName: filterByParentName
  };
}

function makeInputObjectInFilter$1(_in, param) {
  return {
    _in: _in
  };
}

function makeInputObjectStringEqualsFilter$1(_equals, param) {
  return {
    _equals: _equals
  };
}

function makeDefaultVariables$1() {
  return {
    filterByShopIds: undefined,
    filterByName: undefined,
    filterByParentName: undefined
  };
}

let CategoriesQuery_inner = {
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  serializeInputObjectInFilter: serializeInputObjectInFilter$1,
  serializeInputObjectStringEqualsFilter: serializeInputObjectStringEqualsFilter$1,
  makeVariables: makeVariables$1,
  makeInputObjectInFilter: makeInputObjectInFilter$1,
  makeInputObjectStringEqualsFilter: makeInputObjectStringEqualsFilter$1,
  makeDefaultVariables: makeDefaultVariables$1
};

let include$1 = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query$1,
  Raw: Raw$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1
});

let CategoriesQuery_refetchQueryDescription = include$1.refetchQueryDescription;

let CategoriesQuery_use = include$1.use;

let CategoriesQuery_useLazy = include$1.useLazy;

let CategoriesQuery_useLazyWithVariables = include$1.useLazyWithVariables;

let CategoriesQuery = {
  CategoriesQuery_inner: CategoriesQuery_inner,
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  serializeInputObjectInFilter: serializeInputObjectInFilter$1,
  serializeInputObjectStringEqualsFilter: serializeInputObjectStringEqualsFilter$1,
  makeVariables: makeVariables$1,
  makeInputObjectInFilter: makeInputObjectInFilter$1,
  makeInputObjectStringEqualsFilter: makeInputObjectStringEqualsFilter$1,
  makeDefaultVariables: makeDefaultVariables$1,
  refetchQueryDescription: CategoriesQuery_refetchQueryDescription,
  use: CategoriesQuery_use,
  useLazy: CategoriesQuery_useLazy,
  useLazyWithVariables: CategoriesQuery_useLazyWithVariables
};

function useCategoriesUpdater(onSuccess) {
  let client = ReasonMLCommunity__ApolloClient.React.useApolloClient();
  let match = React.useState(() => "Idle");
  let setStatus = match[1];
  let executeAll = React.useCallback(requestsVariables => {
    setStatus(param => "Loading");
    Future.get(Future.all(requestsVariables.map(variables => Future.map(FuturePromise.fromPromise(client.rescript_query({
      query: query$1,
      Raw: Raw$1,
      parse: parse$1,
      serialize: serialize$1,
      serializeVariables: serializeVariables$1
    }, undefined, undefined, "NetworkOnly", undefined, variables)), undefined, response => {
      if (response.TAG !== "Ok") {
        return {
          TAG: "Error",
          _0: Request.serverErrorMessage
        };
      }
      let match = response._0;
      if (match.TAG !== "Ok") {
        return {
          TAG: "Error",
          _0: Request.serverErrorMessage
        };
      }
      let match$1 = match._0;
      if (match$1.error !== undefined) {
        return {
          TAG: "Error",
          _0: Request.serverErrorMessage
        };
      } else {
        return {
          TAG: "Ok",
          _0: match$1.data.categories
        };
      }
    }))), results => {
      results.forEach(result => {
        if (result.TAG === "Ok") {
          return onSuccess(result._0);
        } else {
          return setStatus(param => "Error");
        }
      });
      setStatus(current => {
        if (current === "Error") {
          return "Error";
        } else {
          return "Done";
        }
      });
    });
  }, []);
  return [
    executeAll,
    match[0]
  ];
}

let Fetcher = {
  useCategoriesUpdater: useCategoriesUpdater
};

function CatalogDuplicationFormSelectionTableCard(props) {
  let onError = props.onError;
  let duplicationMode = props.duplicationMode;
  let reference = props.reference;
  let match = useLazy(undefined, undefined, undefined, undefined, "CacheAndNetwork", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let queryResults = match[1];
  let executeQuery = match[0];
  let match$1 = useLazy(undefined, undefined, undefined, undefined, "NoCache", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let queryFilteringResults = match$1[1];
  let executeFilteringQuery = match$1[0];
  let match$2 = React.useState(() => []);
  let setRowsCategoryData = match$2[1];
  let rowsCategoryData = match$2[0];
  let state = CatalogDuplicationForm.useFormState();
  let dispatch = CatalogDuplicationForm.useFormDispatch();
  let shops = Auth.useShops();
  let match$3 = state.values.source;
  let sourceShopId;
  if (match$3 !== undefined) {
    let shopId = match$3._0.shopId;
    sourceShopId = shopId !== undefined ? shopId : undefined;
  } else {
    sourceShopId = undefined;
  }
  React.useEffect(() => {
    if (reference !== undefined) {
      let productProducer = reference.productProducer;
      let productColor = reference.productColor;
      executeQuery(undefined, undefined, {
        filterBy: makeInputObjectInputProductsQueryFilter({
          _equals: reference.productName
        }, {
          _equals: reference.productKind
        }, productProducer !== undefined ? ({
            _equals: productProducer
          }) : undefined, productColor !== undefined ? ({
            _equals: productColor
          }) : undefined, undefined, undefined, "INCLUDED", undefined)
      });
      executeFilteringQuery(undefined, undefined, {
        filterBy: makeInputObjectInputProductsQueryFilter(undefined, undefined, undefined, undefined, {
          _in: reference.variantsCku
        }, undefined, "INCLUDED", undefined)
      });
    }
  }, [sourceShopId]);
  let productsFromInformation;
  if (queryResults.TAG === "Executed") {
    let match$4 = queryResults._0;
    let match$5 = match$4.data;
    if (match$5 !== undefined) {
      productsFromInformation = match$5.products.edges;
    } else {
      let match$6 = match$4.previousData;
      productsFromInformation = match$6 !== undefined && match$6.TAG === "Ok" ? match$6._0.products.edges : undefined;
    }
  } else {
    productsFromInformation = undefined;
  }
  let productsFromCkus;
  if (queryFilteringResults.TAG === "Executed") {
    let match$7 = queryFilteringResults._0;
    let match$8 = match$7.data;
    if (match$8 !== undefined) {
      productsFromCkus = match$8.products.edges;
    } else {
      let match$9 = match$7.previousData;
      productsFromCkus = match$9 !== undefined && match$9.TAG === "Ok" ? match$9._0.products.edges : undefined;
    }
  } else {
    productsFromCkus = undefined;
  }
  let shopList = React.useMemo(() => {
    if (productsFromInformation === undefined) {
      return [];
    }
    if (productsFromCkus === undefined) {
      return [];
    }
    let products = productsFromInformation.concat(productsFromCkus);
    return shops.map(shop => {
      let match = products.find(param => param.node.shop.id === shop.id);
      let tmp;
      if (duplicationMode === "Product") {
        tmp = match !== undefined ? "ExistsAlready" : "Duplicable";
      } else if (match !== undefined) {
        let match$1 = match.node.variants.edges.find(param => param.node.cku === state.id);
        tmp = match$1 !== undefined ? "ExistsAlready" : "Duplicable";
      } else {
        tmp = "MissingProduct";
      }
      return {
        dataId: shop.id,
        dataName: shop.name,
        duplicability: tmp
      };
    });
  }, [
    productsFromInformation,
    productsFromCkus
  ]);
  let availableShopList = React.useMemo(() => Stdlib_Option.mapOr(sourceShopId, [], sourceShopId => shopList.filter(shop => shop.dataId !== sourceShopId)), [
    shopList,
    sourceShopId
  ]);
  let errorReported = React.useRef(false);
  ReactUpdateEffect.use1(() => {
    if (!errorReported.current) {
      let match = availableShopList.length !== 0;
      let match$1 = availableShopList.every(shop => shop.duplicability !== "Duplicable");
      let match$2 = availableShopList.some(shop => shop.duplicability === "MissingProduct");
      if (match) {
        if (match$2) {
          errorReported.current = true;
          onError("MissingProduct");
        } else if (match$1) {
          errorReported.current = true;
          onError("ExistsAlready");
        }
      }
    }
  }, [availableShopList]);
  React.useEffect(() => {
    errorReported.current = false;
  }, [sourceShopId]);
  let onRequestCategoryUpdate = React.useCallback(newCategory => setRowsCategoryData(categories => {
    let index = Stdlib_Array.findIndexOpt(categories, param => param.shopId === newCategory.shopId);
    if (index !== undefined) {
      return categories.map((category, currentIndex) => {
        if (currentIndex === index) {
          return newCategory;
        } else {
          return category;
        }
      });
    } else {
      return categories.concat([newCategory]);
    }
  }), []);
  let match$10 = useCategoriesUpdater(categories => {
    Stdlib_Option.map(categories.edges[0], param => {
      let node = param.node;
      onRequestCategoryUpdate({
        id: node.id,
        name: node.formattedName,
        shopId: node.shop.id
      });
    });
  });
  let executeCategoriesUpdate = match$10[0];
  let productsData = React.useMemo(() => {
    if (productsFromInformation !== undefined) {
      if (productsFromCkus !== undefined) {
        return productsFromInformation.concat(productsFromCkus).map(param => {
          let product = param.node;
          return {
            productId: product.id,
            productShopId: product.shop.id,
            productCategoryFormattedName: Stdlib_Option.getOr(Stdlib_Option.map(product.category, param => param.formattedName), I18n.t("Not classified")),
            productCategoryName: Stdlib_Option.map(product.category, param => param.name),
            productCategoryParentName: Stdlib_Option.map(Stdlib_Option.flatMap(product.category, param => param.parent), param => param.name)
          };
        });
      } else {
        return [];
      }
    } else {
      return [];
    }
  }, [
    productsFromInformation,
    productsFromCkus
  ]);
  ReactUpdateEffect.use3(() => {
    if (productsData.length !== 0) {
      let sourceProductData = productsData.find(param => Primitive_object.equal(param.productShopId, sourceShopId));
      executeCategoriesUpdate(Stdlib_Array.filterMap(availableShopList, shop => {
        let match = shop.duplicability;
        if (duplicationMode !== "Product") {
          return;
        }
        switch (match) {
          case "Duplicable" :
            if (sourceProductData === undefined) {
              return;
            }
            let categoryName = sourceProductData.productCategoryName;
            if (categoryName === undefined) {
              return;
            }
            let productCategoryParentName = sourceProductData.productCategoryParentName;
            return {
              filterByShopIds: {
                _in: [shop.dataId]
              },
              filterByName: {
                _equals: categoryName
              },
              filterByParentName: productCategoryParentName !== undefined ? ({
                  _equals: productCategoryParentName
                }) : undefined
            };
          case "ExistsAlready" :
          case "MissingProduct" :
            return;
        }
      }));
    }
  }, [
    productsData,
    availableShopList,
    sourceShopId
  ]);
  let columns = React.useMemo(() => {
    let everyShopsDuplicable = availableShopList.length !== 0 && availableShopList.every(shop => shop.duplicability === "Duplicable");
    return CatalogDuplicationSelectionTable.tableColumns(everyShopsDuplicable, duplicationMode === "Variant", onRequestCategoryUpdate);
  }, [
    availableShopList,
    sourceShopId
  ]);
  let rows = React.useMemo(() => Stdlib_Array.filterMap(availableShopList, shop => {
    let match = shop.duplicability;
    let note;
    switch (match) {
      case "Duplicable" :
        note = undefined;
        break;
      case "ExistsAlready" :
        note = I18n.t("Reference already existing");
        break;
      case "MissingProduct" :
        note = I18n.t("Reference not duplicable, missing product");
        break;
    }
    let match$1 = productsData.find(param => param.productShopId === shop.dataId);
    if (duplicationMode === "Product") {
      return {
        id: {
          TAG: "Product",
          _0: {
            id: "",
            shopId: shop.dataId
          }
        },
        shopId: shop.dataId,
        shopName: shop.dataName,
        categoryName: Stdlib_Option.map(match$1, param => param.productCategoryFormattedName),
        note: note
      };
    } else {
      return {
        id: Stdlib_Option.map(match$1, param => ({
          TAG: "Product",
          _0: {
            id: param.productId,
            shopId: shop.dataId
          }
        })),
        shopId: shop.dataId,
        shopName: shop.dataName,
        categoryName: undefined,
        note: note
      };
    }
  }), [
    availableShopList,
    sourceShopId
  ]);
  let rows$1 = React.useMemo(() => {
    if (duplicationMode === "Product") {
      return rows.map(row => {
        let match = rowsCategoryData.find(param => param.shopId === row.shopId);
        if (match === undefined) {
          return row;
        }
        let id = match.id;
        if (id !== undefined) {
          return {
            id: {
              TAG: "Category",
              _0: {
                id: id,
                shopId: match.shopId
              }
            },
            shopId: row.shopId,
            shopName: row.shopName,
            categoryName: match.name,
            note: row.note
          };
        } else {
          return {
            id: {
              TAG: "Product",
              _0: {
                id: "",
                shopId: match.shopId
              }
            },
            shopId: row.shopId,
            shopName: row.shopName,
            categoryName: match.name,
            note: row.note
          };
        }
      });
    } else {
      return rows;
    }
  }, [
    rows,
    rowsCategoryData
  ]);
  let disabledRowsKeys = React.useMemo(() => Stdlib_Array.filterMap(shopList, shop => {
    let match = shop.duplicability;
    switch (match) {
      case "Duplicable" :
        return;
      case "ExistsAlready" :
      case "MissingProduct" :
        return shop.dataId;
    }
  }), [availableShopList]);
  let match$11 = state.values;
  let placeholderEmptyState;
  let exit = 0;
  let exit$1 = 0;
  if (match$11.source !== undefined && Primitive_object.equal(rows$1, [])) {
    placeholderEmptyState = JsxRuntime.jsx(Placeholder.make, {
      status: "Loading"
    });
  } else {
    exit$1 = 3;
  }
  if (exit$1 === 3) {
    let exit$2 = 0;
    if (queryResults.TAG === "Executed" && queryResults._0.loading) {
      exit = 2;
    } else {
      exit$2 = 4;
    }
    if (exit$2 === 4) {
      switch (match$10[1]) {
        case "Loading" :
        case "Error" :
          exit = 2;
          break;
        case "Idle" :
        case "Done" :
          exit = 1;
          break;
      }
    }
  }
  switch (exit) {
    case 1 :
      placeholderEmptyState = JsxRuntime.jsx(Box.make, {
        children: JsxRuntime.jsx(Inline.make, {
          children: JsxRuntime.jsx(TextStyle.make, {
            children: I18n.t("Please select the shop catalog to duplicate from in order to select the targeted catalogs."),
            align: "center",
            variation: "normal",
            size: "small"
          }),
          align: "center"
        }),
        spaceX: "large",
        spaceY: "xlarge",
        style: {
          backgroundColor: "#f8f8fb"
        }
      });
      break;
    case 2 :
      placeholderEmptyState = JsxRuntime.jsx(Placeholder.make, {
        status: "Loading"
      });
      break;
  }
  let onSelectChange = React.useCallback(selectedRowsKeys => dispatch({
    TAG: "FieldValueChanged",
    _0: "Destinations",
    _1: param => {
      if (typeof selectedRowsKeys !== "object") {
        return Stdlib_Array.filterMap(rows$1, row => {
          if (!disabledRowsKeys.some(shopId => shopId === row.shopId)) {
            return row.id;
          }
        });
      } else {
        return Stdlib_Array.filterMap(selectedRowsKeys._0, shopId => Stdlib_Option.flatMap(rows$1.find(row => row.shopId === shopId), row => row.id));
      }
    }
  }), [rows$1]);
  return JsxRuntime.jsx(Card.make, {
    children: JsxRuntime.jsx(CatalogDuplicationSelectionTable.make, {
      data: {
        TAG: "Done",
        _0: {
          TAG: "Ok",
          _0: rows$1
        }
      },
      columns: columns,
      keyExtractor: CatalogDuplicationSelectionTable.Row.keyExtractor,
      disabledRowsKeys: disabledRowsKeys,
      selectionEnabled: true,
      initialAllSelected: true,
      hideCard: true,
      placeholderEmptyState: placeholderEmptyState,
      onSelectChange: onSelectChange
    }),
    variation: "table",
    grow: true
  });
}

let make = React.memo(CatalogDuplicationFormSelectionTableCard);

let SelectionTable;

export {
  SelectionTable,
  CatalogDuplication_ProductIdNotFound,
  ProductsQuery,
  CategoriesQuery,
  Fetcher,
  make,
}
/* query Not a pure module */
